import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../auth/authSlice";

// import { getBrandCampaignsCall } from "Common/Repository";
import { getBrandCampaignsCall } from "actions/myCampaignAction";

const initialState = {
    loading: false,
    myCampaignsData: [],
    myCampaignsCurrentPage: 1,
    myCampaignsTotalPages: 0,
    error: null,
    success: false,
};


const myCampaignsSlice = createSlice({
    name: "myCampaigns",
    initialState,
    reducers: {
      setMyCampaigns: (state, action) => {
        state.myCampaignsData = action.payload;
      },
      setMyCampaignsCurrentPage: (state, action) => {
        state.myCampaignsCurrentPage = action.payload;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(logout, (state) => {
          state.myCampaignsData = [];
        })
        .addCase(getBrandCampaignsCall.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getBrandCampaignsCall.fulfilled, (state, action) => {

          // console.log(action.payload);
          // check late : Logic here wrong ?? => optimize BE
          // old logic
          state.myCampaignsData = action.payload?.data?.data;
          state.myCampaignsCurrentPage = action.payload?.data?.current_page;
          state.myCampaignsTotalPages = action.payload?.data?.last_page;
          // // new logic to working
          state.myCampaignsData = action.payload.data;

          state.loading = false;
          state.error = null;
        })
        .addCase(getBrandCampaignsCall.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    },
  });
  

export const { setMyCampaigns,setMyCampaignsCurrentPage } = myCampaignsSlice.actions;
export default myCampaignsSlice.reducer;
